
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5L7 10L12 5"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>
</template>
